import React from "react";

// Lightweight markdown renderer (headings, bold, lists, hr, paragraphs)
function renderInline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) {
      return <strong key={i}>{p.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{p}</React.Fragment>;
  });
}

export default function Markdown({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let list = [];
  const flush = () => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${blocks.length}`}>
          {list.map((li, i) => (
            <li key={i}>{renderInline(li)}</li>
          ))}
        </ul>
      );
      list = [];
    }
  };
  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^###\s/.test(line)) { flush(); blocks.push(<h3 key={idx}>{renderInline(line.replace(/^###\s/, ""))}</h3>); }
    else if (/^##\s/.test(line)) { flush(); blocks.push(<h2 key={idx}>{renderInline(line.replace(/^##\s/, ""))}</h2>); }
    else if (/^#\s/.test(line)) { flush(); blocks.push(<h1 key={idx}>{renderInline(line.replace(/^#\s/, ""))}</h1>); }
    else if (/^[-*]\s/.test(line)) { list.push(line.replace(/^[-*]\s/, "")); }
    else if (/^\d+\.\s/.test(line)) { list.push(line.replace(/^\d+\.\s/, "")); }
    else if (/^---+$/.test(line)) { flush(); blocks.push(<hr key={idx} />); }
    else if (line.trim() === "") { flush(); }
    else { flush(); blocks.push(<p key={idx}>{renderInline(line)}</p>); }
  });
  flush();
  return <div className="md">{blocks}</div>;
}
